import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

export default function BlogStickyCta() {
  const [dismissed, setDismissed] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const updateVisibility = () => {
      const hero = document.querySelector(".blog-post-hero");
      const related = document.querySelector(".related-blog-v3");

      if (!hero) {
        setIsVisible(false);
        return;
      }

      // Show after hero fully leaves the top…
      const pastHero = hero.getBoundingClientRect().bottom <= 0;
      // …and hide once related posts section reaches the viewport
      const relatedStarted = related
        ? related.getBoundingClientRect().top <= window.innerHeight
        : false;

      setIsVisible(pastHero && !relatedStarted);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);

    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, []);

  if (dismissed) return null;

  return (
    <aside
      className={`blog-sticky-cta${isVisible ? " is-visible" : ""}`}
      aria-hidden={!isVisible}
    >
      <button
        type="button"
        className="blog-sticky-cta-close"
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
      >
        <Image
          src="/images/blog/v2/close-cta.svg"
          alt="Dismiss"
          width={24}
          height={24}
          unoptimized
        />
      </button>
      <h3>Try Middleware</h3>
      <p>
        14 days free trial with unlimited data ingestion and then pay as you go.
      </p>
      <Link
        href="https://app.middleware.io/auth/register/"
        target="_blank"
        rel="noopener noreferrer"
        className="blog-sticky-cta-btn"
        tabIndex={isVisible ? 0 : -1}
      >
        Get Started
      </Link>
    </aside>
  );
}
